export default __webpack_public_path__ + "static/media/cif-uz.e2a62191.svg";